import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.js';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    // 显示加载状态
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
          <p className="text-gray-400">加载中...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // 未登录，重定向到登录页面，并携带当前路径作为redirect参数
    const currentPath = window.location.pathname + window.location.search;
    return <Navigate to="/login" state={{ from: currentPath }} replace />;
  }

  // 已登录，显示请求的组件
  return children;
};

export default ProtectedRoute;